var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZimbabwePowerPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    id: "zimbabwe_power_play_Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 360 242",
    style: {
      enableBackground: "new 0 0 360 242"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m315.55 84.04.04.79-15.14-7.86v2.94l-.51-2.77-17.01-6.37-5.57 27.55-5.68-2.27-.08-8.3 4.19.25V69.46L264.48 66c-.22-6.16-2.8-17.45-17.4-25.34l-.34-.17c-.4-.18-10.05-4.39-26.99-6.7l-5.42-.74v29.4l6.63 1.23-1.01 37.21h-6.87v4.43l-1.91.31-.73-6.57-4.93-.49-1.59-7.17c2.21-2.37 4.59-6.73 4.96-14.61.57-6.69-1.22-18.62-11.5-21.4l-.41-.09c-.27-.05-5.86-1.03-14.16-.61l-.47-1.88-36.16 1.63v2.51l-14.32 1.51.29 13.91-1.99.4-.26-13.52-24.28 5.67-.03.78c-1.48-.8-3.2-1.3-5.2-1.24-1.45-.1-5.66-.07-10.05 2.59l-.01-.54c.05-1.89.02-13.5-7.2-20.77-3.64-3.66-8.59-5.55-14.23-5.5-2.35-.31-10.59-.78-22.24 5.29l-13.05 7.15v39.27l6.77-3.65 2.11 57.31-4.39 2.44v33.04l36-15.62v-30.69l-7.7.51-.39-9.45c2.83-1.15 6.74-3.26 10.57-7.05.87 7.7 3.22 15.78 8.95 18.98 1.36.82 3.54 1.73 6.16 2.14-2.81 11.74-5.21 29.12-2.39 49.39 0 0 2.85 22.59 28.06 20.19.62-.06 1.25-.13 1.89-.22 26.96-3.74 26.21-13.73 63.9-12.23 0 0 49.92 5.74 61.4-5.74 0 0 9.49-5.49 19.22-29.2 0 0 9.54-26.85 39.87-26.03l25.95 12.36.85-20.03-3.3-2.28-.16-7.17 5.06-6.61 6.63 2.81V96.58l-23.12-12.54z",
    style: {
      fill: "#221f1f"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M93.02 120.07s-12.78 27.71-7.53 65.4c0 0 2.85 22.59 28.06 20.19.62-.06 1.25-.13 1.89-.22 26.96-3.74 26.21-13.73 63.9-12.23 0 0 49.92 5.74 61.4-5.74 0 0 9.49-5.49 19.22-29.2 0 0 7.49-22.46 31.95-26.71l9.49-.25-1.75-10.23-44.43-26.9-162.2 25.89z",
    style: {
      fill: "#ea1f27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.89 207.74c-23.22 0-26.26-21.81-26.29-22.04-5.26-37.79 7.16-65.28 7.69-66.44l.43-.92 163.9-26.17 45.77 27.72 1.26 12.58-10.54.99c-22.89 4.05-30.26 25.2-30.33 25.41-9.19 22.4-18.25 29.07-19.84 30.11-12.26 11.79-60.74 6.37-62.81 6.13-22.4-.89-31 2.42-40.11 5.91-6.17 2.37-12.54 4.82-23.31 6.31-.67.09-1.33.17-1.97.23-1.35.12-2.63.18-3.85.18zm-15.52-85.95c-2.08 5.07-11.56 30.53-6.99 63.42.11.87 2.98 20.74 25.99 18.55.59-.06 1.19-.13 1.81-.21 10.33-1.44 16.5-3.8 22.46-6.09 9.48-3.64 18.45-7.09 41.77-6.15 13.77 1.58 51.1 3.7 59.98-5.18l.39-.3c.08-.05 9.13-5.66 18.41-28.28.28-.84 8.09-23.48 33.39-27.86l.28-.03 7.28-.19-1.23-7.2-43.09-26.09-160.45 25.61z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m311.73 80.23.04.79-15.14-7.86v2.94l-.51-2.77-17.01-6.37-5.57 27.55-5.68-2.27-.08-8.3 4.19.25V65.64l-11.31-3.46c-.22-6.16-2.8-17.45-17.4-25.34l-.34-.17c-.4-.18-10.05-4.39-26.99-6.7l-5.42-.74v29.4l6.63 1.23-1.01 37.21h-6.87v25.69l36.75 4.72v-9.77l3.5.53c28.8 3.57 57.91 16.15 57.91 16.15 11.43 4.92 19.22 9.63 19.22 9.63v-19.47l-3.3-2.28-.16-7.17 5.06-6.61 6.63 2.81V92.76l-23.14-12.53zM201.7 94.74l-1.59-7.17c2.21-2.37 4.59-6.73 4.96-14.61.57-6.69-1.22-18.62-11.5-21.4l-.41-.09c-.27-.05-5.86-1.03-14.16-.61l-.47-1.88-36.16 1.63v2.51l-14.32 1.51.29 13.91-1.99.4-.26-13.52-24.28 5.67-.03.78c-1.48-.8-3.2-1.3-5.2-1.24-1.45-.1-5.66-.07-10.05 2.59l-.01-.54c.05-1.89.02-13.5-7.2-20.77-3.64-3.66-8.59-5.55-14.23-5.5-2.35-.31-10.59-.78-22.24 5.29L29.8 48.85v39.27l6.77-3.65 2.11 57.31-4.39 2.44v33.04l36-15.62v-30.69l-7.7.51-.39-9.45c2.83-1.15 6.74-3.26 10.57-7.05.87 7.7 3.22 15.78 8.95 18.98 2.74 1.65 8.87 3.7 15.08 1.24 5.77-2.29 10.22-7.72 13.28-16.18.4 2.66.71 4.28.94 4.85l1.55 3.87 15.04-3.76 1.41-8.14 2.06 6.55 13.16-1.82v.21l5.68-1.25c.2-.05 20.22-4.42 35.49-3.92l5.94.27v-.23h17.53l-2.26-20.37-4.92-.52z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zimbabwe_power_play_SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.57,
    y1: 102.345,
    x2: 330.107,
    y2: 102.345
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#251b4e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    style: {
      stopColor: "#44327a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    style: {
      stopColor: "#553e92"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.05 45.93c11.98-6.24 19.72-4.74 19.72-4.74 17.72-.5 16.97 21.47 16.97 21.47L82 76.14C86.99 64.15 96.47 65.4 96.47 65.4c5.74-.25 7.49 6.99 7.49 6.99h2.25l.25-7.49 14.98-3.49.25 12.98-3.74.75 3.24 17.72 3.49-18.72 6.24-1.25 6.24 17.72V70.39l-3.99.5-.25-11.98 14.23-1.5v-2.25l27.71-1.25.5 2c9.98-1 16.97.25 16.97.25 9.24 2.5 7.99 16.47 7.99 16.47-.5 11.23-5.51 13.04-5.51 13.04l2.98 13.47 4.52.45 1.25 11.23h-13.48l-.25-10.98h1.5l-2.75-11.73h-5.4v11.73h3.4v10.98c-16.22-.75-37.69 3.99-37.69 3.99l-.25-12.73 3.49-.73v-32.2l-5.49.48-4.99 46.43-7.24 1-6.74-21.47-4.24 24.46-7.99 2c-1-2.5-5.49-46.18-5.49-46.18l-3 1.5c3.37 22.84 0 35.58 0 35.58-7.11 26.59-22.84 16.84-22.84 16.84-8.99-4.87-6.74-30.7-6.74-30.7-6.74 17.22-20.09 19.47-20.09 19.47l.75 17.97 7.49-.5v22.46l-26.46 11.48v-22.96l4.49-2.5-2.5-67.89-6.49 3.49V51.67l10.49-5.74zM215.29 34.7v19.97l6.74 1.25-1.25 45.93h-6.74v16.72l27.21 3.49v-16.55l-7.24-1.92V90.11s14.23 4.99 19.97-7.83v21.06h-3.74v10.19s28.21 4.29 35.69 8.53v-8.53l-3.99-1.95.5-4.74 7.24 1.25 2.11 6.86-2.86-.37-.29 8.74s10.03 3.24 14.02 4.99v-9.24l-3.49-2.5-7.24-39.72-9.24-3.46-6.83 33.78-1.16-7.07-5.49-2.19-.5 7.6-5.49-1.17-.25-25.46 4.24.25v-9.96l-11.48-3.52s3-15.04-14.73-24.62c0 0-9.24-4.08-25.71-6.33zm86.11 46.31v9.85l3.24 2 6.99 14.98v14.23l-3.99-1 .25 8.49s8.74 2.5 13.98 6.49v-8.99l-3.24-2.25-.25-11.28 8.33-10.88 3.4 1.44V95.6l-13.17-7.13.44 8.57 2 .86-3.62 4.69-3.38-6.76 2.02.84-.26-9.05-12.74-6.61z",
    style: {
      fill: "url(#zimbabwe_power_play_SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#221f1f"
    },
    d: "m102.74 155.97 4.56 7.43 5.51-3.71v20.26l-5.03 1.92v10.31l22.05-5.52v-9.35l-6.47.48-.48-34.53-8.87-2.39zm29.01 19.66v10.55l25.42-5.27v-11.03l-11.51 1.44 8.87-12.47s8.63-15.58-6.23-20.14c0 0-12.71-4.56-20.14 8.39l6.71 7.91 2.64-2.16s2.7-2.64 4.92-.48c0 0 2.21 1.26-1.09 6.24l-9.59 17.02zm44.36-50.11-20.62 66.66 10.31-6 18.46-56.1zm7.04 16.54 7.46 8.15s2.52-4.08 6.36-2.16c0 0 2.88 3.6-3.12 8.63l-8.63 9.83.48 11.03 27.09-1.2v-9.83h-13.67l8.87-9.11s2.88-1.68 3.12-6.95c0 0 1.2-12.05-11.99-13.67.01.01-10.76-1.96-15.97 5.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#221f1f"
    },
    d: "M211.89 137.93v21.88h12.89v7.79l-5.99-.12v8.15h20.86v-7.43l-5.04-.48v-7.43h5.04v-7.92l-4.56-.23-.24-8.88-10.07-.24v7.92l-4.31-.24-.24-12.77z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "m99.47 152.76 4.55 7.44 5.52-3.72v20.26l-5.04 1.92v10.31l22.06-5.52v-9.35l-6.47.48-.48-34.52-8.87-2.4zm29.01 19.66v10.55l25.42-5.27v-11.03l-11.51 1.44 8.87-12.47s8.63-15.58-6.23-20.14c0 0-12.71-4.56-20.14 8.39l6.71 7.91 2.64-2.16s2.7-2.64 4.92-.48c0 0 2.21 1.26-1.09 6.24l-9.59 17.02zm44.36-50.11-20.62 66.66 10.31-6 18.46-56.1zm7.04 16.55 7.46 8.15s2.52-4.08 6.36-2.16c0 0 2.88 3.6-3.12 8.63l-8.63 9.83.48 11.03 27.09-1.2v-9.83h-13.67l8.87-9.11s2.88-1.68 3.12-6.95c0 0 1.2-12.05-11.99-13.67 0 0-10.76-1.96-15.97 5.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M208.62 134.72v21.88h12.89v7.79l-6-.12v8.15h20.86v-7.43l-5.03-.48v-7.43h5.03v-7.91l-4.55-.24-.24-8.87-10.07-.24v7.91l-4.32-.24-.24-12.77z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.79 70.39v22.46s8.49 0 9.98-13.23c0 .01 2.25-14.72-9.98-9.23zm38.19 11.99s-8.24-1.36-8.24 17.22c0 0-1.75 15.26 6.36 14.73 0 0 6.12 1 6.37-18.47 0-.01 0-14.85-4.49-13.48zm65.14-15.23v9.73h5.49v10.99h-5.49v12.23h7.74v-9.24h7.99V67.15h-2v5.49h-7.74v-5.49zm23.06 0v9.49s7.65 1.75 7.65-4.74c0-.01 1.67-6.75-7.65-4.75zm103.31 20.02-2.62 12.93 5.24 1.06zm-51.48-30.25v16.72s9.24 2.25 9.24-6.49c-.01 0 1.24-9.24-9.24-10.23z",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m209.69 79.91 23.73-70.76-38.52 84.13 15.21-3.87-6.67 21.25-4.67-5.59 1.27 24.12 18.29-17.65-8.73 1.6 14.7-36.25z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "m209.02 78.31 23.74-70.75-38.52 84.12 15.21-3.87-6.67 21.25-4.68-5.59 1.27 24.12 18.3-17.64-8.73 1.59 14.7-36.25z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zimbabwe_power_play_SVGID_00000069391841812420322730000010974300591098162561_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.391,
    y1: 112.621,
    x2: 234.133,
    y2: 20.484
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#eea22b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    style: {
      stopColor: "#f4d326"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    style: {
      stopColor: "#f7eb24"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#zimbabwe_power_play_SVGID_00000069391841812420322730000010974300591098162561_)"
    },
    d: "m230.76 13.48-33.2 75.39 14.73-3.75-8.73 27.84-3.25-3.88.75 14.23 10.73-10.35-5.93 1.09 14.67-36.17-14.48 3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZimbabwePowerPlay);
export default __webpack_public_path__ + "static/media/zimbabwe_power_play.32d864f485e08e6ad390bd5b6729d845.svg";
export { ForwardRef as ReactComponent };